import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../shared/ErrorFallback";
import InfoPage from "../../info/InfoPage";
import PageLoading from "../../shared/PageLoading";

interface IParams {
	articleId: string;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean | undefined;
	loading: React.ReactElement;
}

const LazyTools = lazy(() => import(/* webpackChunkName: "TomoeTools" */ "./Tools"));

const ToolsPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path, loading, articleId } = props;

	if (loggedIn === undefined) {
		return loading;
	}

	if (!loggedIn) {
		return <InfoPage />;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyTools loading={loading} />
	</ErrorBoundary>;
};

export default ToolsPage;